import { useEffect, useState } from "react";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  where,
} from "firebase/firestore";
import { db } from "@/lib/firebase";
import type { Match } from "@/lib/types";

export function useMatches(clubId: string | undefined) {
  const [matches, setMatches] = useState<(Match & { id: string })[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clubId) {
      setMatches([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, "clubs", clubId, "matches"),
      orderBy("date", "asc")
    );

    const unsub = onSnapshot(q, (snap) => {
      const items = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      })) as (Match & { id: string })[];
      setMatches(items);
      setLoading(false);
    });

    return unsub;
  }, [clubId]);

  return { matches, loading };
}
